import React from 'react';

const ChugumiMatrix = ({ vibeScore, identityScore }) => {
    // 점수 범위: 8 ~ 40
    // 시각적 중앙값: 24 (8과 40의 중간)
    const min = 8;
    const max = 40;
    const range = max - min;

    // 좌표 계산 (0 ~ 100%)
    const xPos = ((vibeScore - min) / range) * 100;
    const yPos = 100 - (((identityScore - min) / range) * 100); // Y축은 위로 갈수록 높은 값이므로 반전

    return (
        <div style={styles.outerContainer}>
            <div style={styles.matrixContainer}>
                {/* 배경 사분면 라벨 */}
                <div style={styles.quadrantLabel.topLeft}>Artistic / Soft</div>
                <div style={styles.quadrantLabel.topRight}>Unique / Masculine</div>
                <div style={styles.quadrantLabel.bottomLeft}>Practical / Cuteness</div>
                <div style={styles.quadrantLabel.bottomRight}>Classic / Coolness</div>

                {/* 축 그리기 */}
                <div style={styles.xAxis}></div>
                <div style={styles.yAxis}></div>

                {/* 축 라벨 */}
                <div style={styles.axisLabel.top}>Unique</div>
                <div style={styles.axisLabel.bottom}>Practical</div>
                <div style={styles.axisLabel.left}>Cuteness</div>
                <div style={styles.axisLabel.right}>Masculine</div>

                {/* 사용자 포인트 */}
                <div
                    style={{
                        ...styles.point,
                        left: `${xPos}%`,
                        top: `${yPos}%`
                    }}
                >
                    <div style={styles.pointPulse}></div>
                    <div style={styles.pointCenter}></div>
                </div>
            </div>

            <div style={styles.scoreInfo}>
                <span>Vibe: {vibeScore}</span>
                <span style={styles.divider}>|</span>
                <span>Identity: {identityScore}</span>
            </div>
        </div>
    );
};

const styles = {
    outerContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '1rem 0'
    },
    matrixContainer: {
        position: 'relative',
        width: '300px',
        height: '300px',
        backgroundColor: 'rgba(255, 255, 255, 0.03)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        overflow: 'hidden'
    },
    xAxis: {
        position: 'absolute',
        top: '50%',
        left: '5%',
        right: '5%',
        height: '1px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        zIndex: 1
    },
    yAxis: {
        position: 'absolute',
        left: '50%',
        top: '5%',
        bottom: '5%',
        width: '1px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        zIndex: 1
    },
    axisLabel: {
        top: { position: 'absolute', top: '2px', left: '50%', transform: 'translateX(-50%)', fontSize: '10px', color: '#94a3b8', fontWeight: 'bold' },
        bottom: { position: 'absolute', bottom: '2px', left: '50%', transform: 'translateX(-50%)', fontSize: '10px', color: '#94a3b8', fontWeight: 'bold' },
        left: { position: 'absolute', left: '2px', top: '50%', transform: 'translateY(-50%) rotate(-90deg)', fontSize: '10px', color: '#94a3b8', fontWeight: 'bold' },
        right: { position: 'absolute', right: '2px', top: '50%', transform: 'translateY(-50%) rotate(90deg)', fontSize: '10px', color: '#94a3b8', fontWeight: 'bold' },
    },
    quadrantLabel: {
        topLeft: { position: 'absolute', top: '20%', left: '20%', fontSize: '9px', color: 'rgba(255,255,255,0.1)', pointerEvents: 'none' },
        topRight: { position: 'absolute', top: '20%', right: '20%', fontSize: '9px', color: 'rgba(255,255,255,0.1)', pointerEvents: 'none' },
        bottomLeft: { position: 'absolute', bottom: '20%', left: '20%', fontSize: '9px', color: 'rgba(255,255,255,0.1)', pointerEvents: 'none' },
        bottomRight: { position: 'absolute', bottom: '20%', right: '20%', fontSize: '9px', color: 'rgba(255,255,255,0.1)', pointerEvents: 'none' },
    },
    point: {
        position: 'absolute',
        width: '14px',
        height: '14px',
        transform: 'translate(-50%, -50%)',
        zIndex: 10,
        transition: 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)'
    },
    pointCenter: {
        width: '100%',
        height: '100%',
        backgroundColor: '#60a5fa',
        borderRadius: '50%',
        boxShadow: '0 0 10px #3b82f6'
    },
    pointPulse: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#60a5fa',
        borderRadius: '50%',
        animation: 'pulse 2s infinite',
        opacity: 0.5
    },
    scoreInfo: {
        marginTop: '1.5rem',
        fontSize: '0.9rem',
        color: '#cbd5e1',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem'
    },
    divider: {
        color: '#475569',
        fontWeight: 'normal'
    }
};

export default ChugumiMatrix;
